import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TuiRoot } from '@taiga-ui/core';
import { take } from 'rxjs';

import { ActiveClinicService } from './core/crm/active-clinic.service';
import { ToastService } from './core/shared/toast.service';
import { ThemeService } from './core/theme/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TuiRoot],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly theme = inject(ThemeService);

  constructor() {
    // Switch clinic: follow a switch made in another tab or in the clinic app, and after a
    // switch say where we are. get(), not instant(): the locale file may not have loaded yet.
    const clinics = inject(ActiveClinicService);
    clinics.listen();
    const switchedTo = clinics.takeSwitchedNotice();
    if (switchedTo) {
      const toast = inject(ToastService);
      inject(TranslateService)
        .get('clinicSwitch.done', { clinic: switchedTo })
        .pipe(take(1))
        .subscribe((text: string) => toast.success(text));
    }
  }
}
